// extracted by mini-css-extract-plugin
module.exports = {"formItem":"formItem--ifoA0"};